import * as React from 'react';
import {styled, mq} from '../../../utils';
import Flex from '../../../components/Flex';
import Text from '../../../components/Text';
import FormField from '../../../components/FormField';
import TextField, {TextFieldProps} from '../../../components/TextField';
import {PillButton} from '../../../components/Button';
import {IconCheckCircle} from '../../../components/SvgIcon';
import {Form, FormikProps} from 'formik';

export interface FormValues {
  email: string;
  name: string;
  about: string;
}

interface CreateTeamFormBaseProps extends FormikProps<FormValues> {
  loading: boolean;
}

// TODO: Add error message display capability to TextField component.
const ErrorMessage = ({children, show}: {children: React.ReactNode; show: boolean}) => {
  if (show) {
    return (
      <Text color="#C00" style={{marginTop: 8}} withComponent="p">
        {children}
      </Text>
    );
  }
  return null;
};

const SubmitButton = styled(PillButton)({
  [mq('laptopAndUp')]: {
    marginBottom: 100
  }
});

export default class CreateTeamFormBase extends React.Component<CreateTeamFormBaseProps, {}> {
  public render() {
    const {values, errors, touched, handleChange, handleBlur, loading} = this.props;

    const commonFieldProps: TextFieldProps = {
      onChange: handleChange,
      onBlur: handleBlur,
      iconPosition: 'end'
    };

    // TODO: add success state to TextField component
    const checkCircle = <IconCheckCircle color="#08C173" />;

    return (
      <Form>
        <FormField label="Name">
          <TextField
            id="name"
            value={values.name}
            icon={!errors.name && touched.name && checkCircle}
            {...commonFieldProps}
          />
          <ErrorMessage show={Boolean(errors.name && touched.name)}>{errors.name}</ErrorMessage>
        </FormField>
        <FormField label="Email">
          <TextField
            type="email"
            id="email"
            value={values.email}
            icon={!errors.email && touched.email && checkCircle}
            {...commonFieldProps}
          />
          <ErrorMessage show={Boolean(errors.email && touched.email)}>{errors.email}</ErrorMessage>
        </FormField>
        <FormField label="Description">
          <TextField multiline={true} id="about" value={values.about} {...commonFieldProps} />
        </FormField>
        <Flex justify="flex-end">
          <SubmitButton type="submit" variant="primary" loading={loading}>
            Next step
          </SubmitButton>
        </Flex>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CreateTeamForm/private/CreateTeamFormBase.tsx